import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { toggleSidebar } from '../../store/actions/layout';

const Footer = () => {
   const dispatch = useDispatch();
   const { isSidebarOpened } = useSelector((state) => state.layout);
   return (
      <footer className='footer' onClick={() => isSidebarOpened && dispatch(toggleSidebar())}>
         <div className='footer__parts'>
            <div className='footer__container'>
               <Link className='footer__logo' to='/'>
                  <img className='footer__logo-img' src='/img/logo-footer.svg' alt='' />
               </Link>
               <div className='footer__connection'>
                  <h4 className='footer__title footer__title--desktop'>تماس با ما</h4>
                  <p className='footer__location'>
                     آدرس :
                     <span className='footer__location-txt'>
                        {' '}
                        اصفهان، اتوبان کاوه، خیابان جابر انصاری، خیابان ابونعیم جنوبی، میدان
                        میرعماد، اتوماسیون مرکزی کالاپست
                     </span>
                  </p>
                  <p className='footer__phone'>
                     شماره تماس : <span>14-03134358310</span>
                  </p>
                  <p className='footer__mail'>
                     ایمیل : <span>kalapost.co@gmail.com</span>
                  </p>
               </div>
            </div>
            <div className='footer__social-usefull'>
               <div className='footer__social'>
                  <h4 className='footer__title'>با ما همراه باشید</h4>
                  <div className='footer__media'>
                     <a href='http://instagram.com/kalapost.ir' target='_blank'>
                        <img
                           className='footer__media-img'
                           src='/img/instagram.png'
                           alt='instagram'
                        />
                     </a>
                     <a href='https://api.whatsapp.com/send?phone=09134200780' target='_blank'>
                        <img className='footer__media-img' src='/img/whatsapp.png' alt='whatsapp' />
                     </a>
                     <a href='https://t.me/@Alinbvi' target='_blank'>
                        <img className='footer__media-img' src='/img/telegram.png' alt='telegram' />
                     </a>
                     <a href='mailto:Kalapost.co@gmail.com'>
                        <img className='footer__media-img' src='/img/email.png' alt='email' />
                     </a>
                  </div>
               </div>
               <a
                  referrerPolicy='origin'
                  target='_blank'
                  href='https://trustseal.enamad.ir/?id=428984&Code=SAvUCtQhhnzDjiOntjvOJrKkSY098L0u'
                  className='footer__enamad'
               >
                  <img
                     referrerPolicy='origin'
                     src='https://trustseal.enamad.ir/logo.aspx?id=428984&Code=SAvUCtQhhnzDjiOntjvOJrKkSY098L0u'
                     alt=''
                     code='SAvUCtQhhnzDjiOntjvOJrKkSY098L0u'
                  />
               </a>
            </div>
         </div>

         <p className='footer__lawer'>
            کلیه حقوق این سایت متعلق به دفتر خدماتی کالارسانان پیشتاز نگین نقش جهان می باشد.
         </p>
         <p className='footer__design-by'>
            طراحی و پیاده سازی
            <a className='footer__design-link' href='https://arminrayan.com/'>
               &nbsp; آرمین رایان اسپادان
            </a>
         </p>
      </footer>
   );
};

export default Footer;
